import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { DataFilterDisplayService } from '../../interface';
import { TranslateService } from '@ngx-translate/core';

@Injectable({ providedIn: 'root' })
export class IsEmptyOptionsDisplayService implements DataFilterDisplayService {
  constructor(private readonly translateService: TranslateService) {}

  getDisplay(value: boolean): Observable<string> {
    const translationKey = value
      ? 'AUTOMATIONS.EDITOR.FILTERS.SHOPPING_CART_CONTENTS.OPTION_LABELS.NOT_EMPTY'
      : 'AUTOMATIONS.EDITOR.FILTERS.SHOPPING_CART_CONTENTS.OPTION_LABELS.EMPTY';
    return of(`<b>${this.translateService.instant(translationKey)}</b>`);
  }
}
